import { useState, type FormEvent } from 'react'
import { Button, Field, Icon, Stack, Text } from '@/design-system'
import { BRAND } from '@/brand/brand'
import { AuthFooter, AuthHeading } from './AuthForm'

export function ForgotPasswordScreen() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)

  function handleSubmit(event: FormEvent) {
    event.preventDefault()
    if (email.includes('@')) setSent(true)
  }

  if (sent) {
    return (
      <Stack gap={5} align="start">
        <Icon name="mark_email_read" size={28} />
        <AuthHeading
          title="Check your email"
          subtitle={`If ${email} has a ${BRAND.name} account, a link to set a new password is on its way. It expires in an hour.`}
        />
        <Stack direction="row" align="center" gap={3}>
          <Icon name="info" size={18} />
          <Text variant="caption" tone="secondary">
            Nothing arrived? Look in spam, then try again — we only send one every two minutes.
          </Text>
        </Stack>
        <Button variant="outline" size="md" to="/login" iconStart="arrow_back">
          Back to log in
        </Button>
      </Stack>
    )
  }

  return (
    <Stack as="form" gap={6} onSubmit={handleSubmit}>
      <AuthHeading
        title="Reset your password"
        subtitle="Tell us the email on the account and we'll send a link to set a new one."
      />
      <Field
        label="Email"
        type="email"
        autoComplete="email"
        placeholder="you@example.com"
        value={email}
        onChange={(event) => setEmail(event.target.value)}
        required
      />
      <Button type="submit" size="lg" block>
        Send the link
      </Button>
      <AuthFooter question="Remembered it?" actionLabel="Log in" to="/login" />
    </Stack>
  )
}
